import { BankAccountDetails } from '@afterpay/types'
import { IconSizes, PaymentIcon } from '@afterpaytouch/core'
import React, { FunctionComponent } from 'react'
import { CardErrorReason } from '../../model'
import { PaymentMethod } from './PaymentMethod'
import { useTranslation } from '../../utils/convergence'
import { PaymentMethodInfo } from './PaymentMethodInfo'

interface Props {
  account?: BankAccountDetails
  iconSize?: IconSizes
  errorKey?: CardErrorReason | null
  disabled?: boolean
  showErrorMessage?: boolean
}

export const BankAccountPayment: FunctionComponent<Props> = ({ account, iconSize, disabled = false, ...props }) => {
  const { t } = useTranslation()

  return (
    <PaymentMethod
      icon={<PaymentIcon.GenericBank size={iconSize} title={t('paymentMethod:bankaccount')} />}
      paymentMethodName={account?.issuingBank ?? ''}
      paymentMethodInfo={<PaymentMethodInfo paymentMethodMasks={account?.numberMask} />}
      disabled={disabled}
      {...props}
    />
  )
}
